export default [
    {
        id :1,
        ZONENAME :"Mitco, Ltd",
        STARTZIP :"UPS",
        ENDZIP :"MITCO LTD UPS",
    },
  ];
  